import React, { type ButtonHTMLAttributes, type FC, type PropsWithChildren } from 'react';

import Icon, { type IconTypes } from '../icon/icon';
import Box from '../box/box';

export interface ControlButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Determines the icon to render within the button */
  iconType: IconTypes;
  /** Determines if the button has a dark background */
  hasDarkBackground?: boolean;
}

const ControlButton: FC<PropsWithChildren<ControlButtonProps>> = ({ iconType, hasDarkBackground, ...rest }) => (
  <button
    {...rest}
    css={theme => ({
      label: 'controlButton',
      cursor: 'pointer',
      background: 'transparent',
      border: `1px solid ${hasDarkBackground ? theme.colors.white : theme.colors.coolGrey[100]}`,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '32px',
      height: '32px',
      '&:hover, &:focus-visible': {
        '&:not([disabled])': {
          border: `2px solid ${hasDarkBackground ? theme.colors.white : theme.colors.coolGrey[100]}`,
          outline: 'none',
        },
      },
      '&:disabled': {
        cursor: 'default',
        opacity: '0.35',
      },
    })}
  >
    <Box
      css={[
        { '& span': { display: 'flex', alignItems: 'center' } },
        iconType === 'PlayOutline' && {
          height: '12px',
          transform: 'translateX(1px)',
        },
      ]}
    >
      <Icon color={hasDarkBackground ? 'white' : 'coolGrey.100'} type={iconType} />
    </Box>
  </button>
);

export default ControlButton;
